import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 flex items-center justify-between px-6 md:px-12 py-6 ${
        scrolled ? 'bg-background/90 backdrop-blur-md border-b border-border/50' : 'bg-transparent text-white'
      }`}
    >
      <div className="text-xl font-editorial tracking-widest uppercase font-medium">
        <a href="#home">Nirvaana</a>
      </div>
      
      <nav className="hidden md:flex items-center gap-8 text-sm font-medium tracking-wide">
        {['About', 'Services', 'Locations', 'Portfolio'].map((item) => (
          <a key={item} href={`#${item.toLowerCase()}`} className="hover:text-secondary transition-colors uppercase text-xs tracking-widest">
            {item}
          </a>
        ))}
      </nav>

      <a 
        href="#contact" 
        className={`px-6 py-2.5 rounded-full text-xs uppercase tracking-widest transition-all duration-300 ${
          scrolled 
            ? 'bg-primary text-primary-foreground hover:bg-secondary' 
            : 'bg-white/20 hover:bg-white text-white hover:text-black backdrop-blur-sm'
        }`}
      >
        Enquire Now
      </a>
    </motion.header>
  );
};
